import { useEffect, useState } from 'react';
import { Card } from '../../components/ui/card';
import { Loader2, AlertTriangle } from 'lucide-react';
import api from '../../lib/api';

const istMonth = () => new Date(Date.now() + 5.5 * 3600e3).toISOString().slice(0, 7);

export const CbtLostEarly = () => {
  const [month, setMonth] = useState(istMonth());
  const [d, setD] = useState(null);
  const [all, setAll] = useState(false);
  useEffect(() => { setD(null); api.get('/callback-tracker/lost-early', { params: { month } }).then(r => setD(r.data)).catch(() => setD(null)); }, [month]);
  const rows = d ? d.rows.filter(r => all || r.flagged) : [];
  return (
    <Card className="p-4" data-testid="cbt-lost-tab">
      <div className="flex flex-wrap items-center gap-2 mb-1">
        <h3 className="text-sm font-bold text-slate-900">Lost too early</h3>
        <input type="month" value={month} max={istMonth()} onChange={e => e.target.value && setMonth(e.target.value)} className="text-xs border border-slate-200 rounded-md px-2 py-1 ml-auto" data-testid="cbt-lost-month" />
        <label className="text-xs text-slate-600 flex items-center gap-1"><input type="checkbox" checked={all} onChange={e => setAll(e.target.checked)} data-testid="cbt-lost-show-all" />Show every lead that left Call Back</label>
      </div>
      {d && <p className="text-[11px] text-slate-500 mb-3">Leads moved from Call Back to {d.settings.lost_statuses.join(' / ')} with fewer than {d.settings.min_attempts} calls. Tracked from the first update onwards. {new Date(`${month}-01T00:00:00`).toLocaleString('en-IN', { month: 'long', year: 'numeric' })}: {d.totals.left} left Call Back, {d.totals.lost} lost, <b className="text-rose-600">{d.totals.flagged} flagged</b>.</p>}
      {!d ? <Loader2 className="w-5 h-5 animate-spin text-slate-400" /> : (
        <table className="w-full text-xs">
          <thead className="text-[10px] uppercase tracking-wider text-slate-400"><tr><th className="text-left py-1">Left on</th><th className="text-left">Lead</th><th className="text-left">Owner</th>
            <th className="text-left">New status</th><th className="text-left">In Call Back since</th><th className="text-right">Calls made</th><th className="text-left pl-3">Flag</th></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={7} className="text-center text-slate-400 py-8">{all ? 'No leads left Call Back this month.' : 'No lead was marked Lost too early this month.'}</td></tr>}
            {rows.map(r => (
              <tr key={`${r.lead_id}-${r.left_on}`} className="border-t border-slate-100" data-testid={`cbt-lost-${r.lead_id}`}>
                <td className="py-1.5">{r.left_on}</td>
                <td><a href={`https://crm.zoho.com/crm/tab/Leads/${r.lead_id}`} target="_blank" rel="noreferrer" className="text-blue-700 hover:underline">{r.name || r.lead_id}</a></td>
                <td>{r.owner}</td><td>{r.new_status}</td><td className="text-slate-500">{r.since}</td>
                <td className={`text-right font-bold ${r.flagged ? 'text-rose-600' : ''}`}>{r.calls}</td>
                <td className="pl-3">{r.flagged && <span className="inline-flex items-center gap-1 text-rose-700 bg-rose-50 px-1.5 py-0.5 rounded"><AlertTriangle className="w-3 h-3" />Only {r.calls} of {d.settings.min_attempts}</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Card>
  );
};
